module.exports = __webpack_public_path__ + "static/img/yytx26.1840e64.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx26.png
// module id = 895
// module chunks = 0